import { Box, Grid, ThemeProvider } from '@mui/material';
import {
  a11yProps,
  CustomTab,
  CustomTabs,
  TabPanel,
  TabTheme,
} from './TabNavigationComponent';
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import LEAPreschoolForm from '../../pages/referral/LEAPreschoolForm';
import LEAReferralConsent from '../../pages/consent/LEAReferralConsent';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import ModalPopup from './ModalPopup';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import { useNavigate } from 'react-router';
import { LEA_REFERRAL_DASHBOARD } from '../../routes/Routing';

const LEATabNavigationComponent = () => {
  const [currentTab, setCurrentTab] = useState<number | null>(null);
  const [openUnSavedModal, setOpenUnSavedModal] = useState<boolean>(false);
  const [pendingPosition, setPendingPosition] = useState<number>(0);
  const { hasUnsavedChanges, handleUpdateUnsavedChanges } = useContext(
    UnSavedChangesContext,
  );
  const intl = useIntl();
  const navigate = useNavigate();
  useEffect(() => {
    const currentTabValue = sessionStorage.getItem('leaReferral');
    setCurrentTab(currentTabValue === null ? 0 : parseInt(currentTabValue));

    return () => {
      sessionStorage.removeItem('leaReferral');
    };
  }, []);

  if (currentTab === null) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <ModalPopup
        open={openUnSavedModal}
        description="UnsavedAlertDescriptionWhileSwitching"
        labelId1="UnSavedAlertCancel"
        labelId2="UnsavedAlertSwitch"
        negativeActionLabel="No"
        positiveActionLabel="Yes"
        onCancel={() => {
          setOpenUnSavedModal(false);
        }}
        onOk={() => {
          sessionStorage.setItem('leaReferral', String(pendingPosition));
          setCurrentTab(pendingPosition);
          handleUpdateUnsavedChanges(false);
          setOpenUnSavedModal(false);
        }}
      />
      <ThemeProvider theme={TabTheme}>
        <Grid container alignItems="center">
          {/* Tab Navigation */}
          <Box
            style={{ cursor: 'pointer', marginLeft: '16px', marginTop: '16px' }}
            onClick={() => navigate(LEA_REFERRAL_DASHBOARD)}
          >
            <CustomBackArrow />
          </Box>
          <Grid item xs={12} sm={9}>
            <CustomTabs
              sx={{ marginLeft: '4px' }}
              value={currentTab}
              onChange={(_, newValue) => {
                setPendingPosition(newValue);
                if (!hasUnsavedChanges) {
                  setOpenUnSavedModal(false);
                  sessionStorage.setItem('leaReferral', String(newValue));
                  setCurrentTab(newValue);
                } else {
                  setOpenUnSavedModal(true);
                }
              }}
            >
              <CustomTab
                {...a11yProps(0)}
                label={intl.formatMessage({
                  id: 'leaConsentTitleSidebar',
                  defaultMessage: 'LEA Consent or Opt Out',
                })}
              />
              <CustomTab
                {...a11yProps(1)}
                label={intl.formatMessage({
                  id: 'LeaSchool.LEAReferralNavigate',
                  defaultMessage: 'LEA Referral and TPC',
                })}
              />
            </CustomTabs>
          </Grid>
        </Grid>

        {/* Tab Panels */}
        <TabPanel value={currentTab} index={0}>
          <LEAReferralConsent />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <LEAPreschoolForm />
        </TabPanel>
      </ThemeProvider>
    </Box>
  );
};

export default LEATabNavigationComponent;